import { sendAnalyticsEvent, UnknownEvent } from '@faststore/sdk'
import { useRef } from 'react'
import { ArcaplanetLogoHeader } from 'src/components/icons/ArcaplanetLogoHeader'
import { ArrowGoBackGlobal } from 'src/components/icons/ArrowGoBackGlobal'
import { XCloseGlobal } from 'src/components/icons/XCloseGlobal'
import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { useOnClickAwayOverlay } from 'src/sdk/ui/useOnClickAwayOverlay'
import { LEVELS } from '../constants'
import { FirstLevel } from './FirstLevel'
import { FourthLevel } from './FourthLevel'
import { SecondLevel } from './SecondLevel'
import { ThirdLevel } from './ThirdLevel'

export const MenuMobile = () => {
  const ref = useRef<HTMLDivElement>(null)

  const { state, dispatch } = useMenu()
  const { openCloseMenu, setOpenCloseMenu } = useGlobalNavigation()

  const handleGoBack = () => {
    dispatch({
      type: 'go_back',
    })
  }

  const handleClickCloseModal = () => {
    sendAnalyticsEvent<UnknownEvent>({
      name: 'menu_categorie',
      params: {
        path: '',
        section: 'hamb_menu',
        main_category: '',
      },
    })
    setOpenCloseMenu(false)
    dispatch({
      type: 'reset',
    })
  }

  useOnClickAwayOverlay({
    isOpened: openCloseMenu,
    overlay: ref,
    callback: handleClickCloseModal,
  })

  return (
    <>
      <div
        className={`fixed top-0 left-0 bottom-0 transition-all w-full max-w-[320px] z-[5] global-navigation-drawer global-navigation-mobile ${
          openCloseMenu ? 'open' : ''
        } ${state.selectedLevel > LEVELS.main ? 'with-back' : ''}`}
      >
        <div className="px-6 pt-6 pb-6 bg-white rounded-tr-2xl border-b border-solid border-[#E2E2E2] global-navigation-header">
          <div className="relative w-full flex justify-between">
            <div className="p-1">
              <ArcaplanetLogoHeader height={36} />
            </div>
            <button
              className="block w-8 h-8 global-nav-close bg-white"
              onClick={() => handleClickCloseModal()}
              aria-label="Chiudi"
            >
              <XCloseGlobal />
            </button>
          </div>
          <button
            className="pt-4 pb-2 hidden flex-row gap-1 items-center text-[#0A0A0A] gotoback-nav-button bg-white"
            onClick={() => handleGoBack()}
          >
            <div className="w-4 h-4">
              <ArrowGoBackGlobal />
            </div>
            <span className="block font-semibold text-xs tracking-[0.048px] !leading-[22px]">
              Torna indietro
            </span>
          </button>
        </div>
        <div className="h-[calc(100%-97px)] w-full overflow-hidden rounded-br-2xl bg-white global-navigation-body">
          <div className="h-full w-full relative">
            {state.selectedLevel === LEVELS.main && <FirstLevel />}
            {state.selectedLevel === LEVELS.second_level && <SecondLevel />}
            {state.selectedLevel === LEVELS.third_level && <ThirdLevel />}
            {state.selectedLevel === LEVELS.fourth_level && <FourthLevel />}
          </div>
        </div>
      </div>
      <div
        ref={ref}
        className="fixed top-0 left-0 transition-all h-screen w-screen bg-[rgba(0,0,0,.3)] z-[-1] opacity-0 global-nav-overlay"
      ></div>
    </>
  )
}
